module.exports = __webpack_public_path__ + "static/hero-b5349a1c3986f2e91f9fa5d814aa4b46.jpg";